<template>
	<div>
		<div class="public-table-data">
			<div class="public-table-but__left">
				<div class="item">
					<!-- <em>筛选：</em> -->
					<div class="item-wp">
						<template>
							<div class="item-son" style="width: 180px">
								<el-select
									filterable
									v-model="pages.batchId"
									clearable
									placeholder="请选择批次"
									style="width: 100%"
								>
									<el-option
										v-for="(item, index) in batchList"
										:key="index"
										:label="item.name"
										:value="item.batchId"
									></el-option>
								</el-select>
							</div>
							<div class="item-son" style="width: 180px">
								<el-select
									filterable
									v-model="pages.countryCode"
									clearable
									placeholder="请选择国家"
									style="width: 100%"
								>
									<el-option
										v-for="(item, index) in selectData"
										:key="index"
										:label="item.name"
										:value="item.code"
									></el-option>
								</el-select>
							</div>

							<div class="item-son">
								<el-select
									v-model="pages.isOpen"
									clearable
									placeholder="请选择状态"
									style="width: 120px"
								>
									<el-option label="上架" :value="true"></el-option>
									<el-option label="下架" :value="false"></el-option>
								</el-select>
							</div>
							<div class="item-son">
								<el-button type="primary" @click="queryTableData"
									>查询 <i class="el-icon-search"></i>
								</el-button>
							</div>
						</template>
						<div class="item-son">
							<el-button type="primary" @click="handleClick('add')"
								>新增 <img src="@assets/images/add-icon.png" alt="" />
							</el-button>

							<el-button type="warning" @click="handleClick('edit')"
								>批量修改
							</el-button>

							<el-button type="danger" @click="handleClick('del')"
								>批量删除
							</el-button>
						</div>
					</div>
				</div>
			</div>
			<el-table
				ref="multipleTable"
				size="mini"
				:data="tableData"
				border
				style="width: 100%"
				row-key="menuId"
				v-loading="loading"
				@selection-change="handleSelectionChange"
			>
				>
				<el-table-column type="selection" width="55"> </el-table-column>
				<el-table-column type="index" label="序号" width="80" align="center">
				</el-table-column>
				<el-table-column prop="name" label="名称" width="180" align="center">
				</el-table-column>
				<el-table-column
					prop="app_exam_id"
					label="标识"
					width="120"
					align="center"
				>
				</el-table-column>
				<el-table-column prop="country_code" label="国家" align="center">
				</el-table-column>
				<el-table-column
					prop="trial_price"
					label="试用金额（$）"
					width="120"
					align="center"
				>
					<template slot-scope="scope">
						{{
							scope.row.trial_price > 0
								? `$${formatMoney(scope.row.trial_price/100)}`
								: `$0`
						}}
					</template>
				</el-table-column>
				<el-table-column
					prop="first_split_payment_amount"
					label="首次支付金额（$）"
					width="150"
					align="center"
				>
					<template slot-scope="scope">
						{{
							scope.row.first_split_payment_amount > 0
								? `$${formatMoney(scope.row.first_split_payment_amount/100)}`
								: `$0`
						}}
					</template>
				</el-table-column>
				<el-table-column
					prop="billing_interval"
					label="循环单位"
					width="150"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="trial_days"
					label="试用期天数"
					width="100"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="interval_count"
					label="间隔数"
					width="120"
					align="center"
				>
				</el-table-column>
				<el-table-column
					prop="total_cycles"
					label="循环扣费（$）"
					width="120"
					align="center"
				>
					<template slot-scope="scope">
						{{
							scope.row.total_cycles == 0 ? "无限次" : `${formatMoney(scope.row.total_cycles/100)}`
						}}
					</template>
				</el-table-column>
				<el-table-column
					prop="price"
					label="周期循环扣费（$）"
					width="130"
					align="center"
				>
					<template slot-scope="scope">
						{{
							scope.row.price != 0
								? `$${formatMoney(scope.row.price/100)}`
								: `$0`
						}}
					</template>
				</el-table-column>
				<el-table-column prop="is_open" label="状态" align="center">
					<template slot-scope="scope">
						<el-switch
							v-model="scope.row.is_open"
							:active-value="1"
							:inactive-value="0"
							@change="changeSwitchIssue(scope.row)"
						>
						</el-switch>
					</template>
				</el-table-column>

				<el-table-column prop="is_recommend" label="是否推荐" align="center">
					<template slot-scope="scope">
						<el-switch
							v-model="scope.row.is_recommend"
							:active-value="1"
							:inactive-value="0"
							@change="changeSwitchRecommend(scope.row)"
						>
						</el-switch>
					</template>
				</el-table-column>

				<el-table-column prop="is_trial" label="是否试用" align="center">
					<template slot-scope="scope">
						<el-switch
							v-model="scope.row.is_trial"
							:active-value="1"
							:inactive-value="0"
							@change="changeSwitchTrial(scope.row)"
						>
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column
					label="操作"
					align="left"
					fixed="right"
					min-width="100"
				>
					<template slot-scope="scope">
						<el-button
							@click="delSub([scope.row])"
							size="mini"
							type="danger"
							plain
							>删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="public-pagination">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pages.pageNo"
					:page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
					:page-size="pages.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				>
				</el-pagination>
			</div>
		</div>
		<el-dialog
			:title="editMode === 'add' ? '订阅-添加' : '订阅-批量修改'"
			:visible.sync="dialogVisible"
			width="600px"
			class="public-dialog"
			append-to-body
		>
			<div class="public-dialog-form">
				<div class="public-dialog-form">
					<el-form
						ref="ruleForm"
						:model="subParams"
						:rules="formModelConfig.rules"
						label-width="120px"
					>
						<template v-for="(item, idx) in formModelConfig.FormData">
							<el-form-item
								v-if="item.el == 'el-radio-group'"
								:key="item.name"
								:label="item.label"
								:prop="item.name"
							>
								<el-radio-group v-model="subParams[item.name]" border>
									<el-radio
										v-for="(v, i) in item.options"
										:key="i"
										:label="v.value"
									>
										{{ v.label }}
									</el-radio>
								</el-radio-group>
							</el-form-item>

							<el-form-item
								v-else
								:label="item.label"
								:prop="item.name"
								:key="idx"
							>
								<component
									:is="item.el"
									v-model="subParams[item.name]"
									v-bind="item.attrs"
									:params="subParams ? subParams : ''"
								/>
							</el-form-item>
						</template>
					</el-form>
				</div>
				<span slot="footer" class="public-dialog-footer">
					<el-button size="medium" @click="dialogVisible = false"
						>取 消</el-button
					>
					<el-button size="medium" type="primary" @click="handleSub">
						提 交
					</el-button>
				</span>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { PAGE_SIZE, FILE_ROOT, JOB_STATUS } from "@config";
import { getEditFormConfig } from "./subTopic.js";
import { formatMoney } from "@utils/filters/filter";
export default {
	props: ["appExamId"],
	data() {
		return {
			total: 0,
			loading: false,
			dialogVisible: false,
			editMode: 'add', // 添加编辑模式 'add' 或 'edit'
			formModelConfig: getEditFormConfig(),
			PAGE_SIZE,
			pages: {
				pageNo: 1,
				pageSize: PAGE_SIZE,
				countryCode: "",
				batchId: "",
			},
			subParams: {
				name: "",
				trialPrice: 0.99, // 首付价格,小数点后两位，美元
				firstSplitPaymentAmount: 0, // 首次支付金额,小数点后两位，美元
				trialDays: 3, // 试用期天数 3天
				currency: "USD", // 货币
				billingInterval: "DAY", // 循环单位，WEEK,MONTH
				intervalCount: 7, // 间隔数
				totalCycles: 0, // 循环扣费5次
				price: 19.99, // 周期循环扣费费用,小数点后两位，美元
				inclusive: true, // 是否额外收取税率，默认为true
				percentage: 0, // 税率
				totalPrice: 0, // 总共费用101美元
				isOpen: true, // 是否上架
				isTrial: 1, // 是否试用
				isRecommend: 1, // 是否推荐
			},
			tableData: [],
			newdata: [], // 已选择的数据
			formatMoney,
			dictDataSelect: "",
			selectData: [],
			batchList: [],
			listParams: {},
			treeProps: {
				//配置选项:此处定义el-tree的label和children为指定属性，  如果不定义取默认，即label和children
				value: "parentId",
				children: "examCategoryVos",
				label: "name",
			},
		};
	},
	created() {
		this.pages.appExamId = this.appExamId;
		this.subParams.appExamId = this.appExamId;
		this.queryTableData();
		this.getCountryList();
		this.getBatchList();
	},
	methods: {
		async getCountryList() {
			const { data: resData } = await this.$post(`/country/page`, {
				pageNo: 1,
				pageSize: 1000,
			});
			// this.countryList = res.data;
			this.loading = false;
			if (resData.result != 200) return;
			this.selectData = resData.data;
		},
		async getBatchList() {
			const { data: resData } = await this.$post(
				"/v1/billing/plans/getBatchList?appExamId=" + this.appExamId,
				{
					appExamId: this.appExamId,
				}
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.batchList = resData.data;
		},
		handleNodeClick: function (node) {
			this.pages.categoryId = node.categoryId;
			this.dictDataSelect = node.name;
			this.queryTableData();

			this.listParams.categoryId = node.categoryId;
			if (node.parentId == 0) {
				this.listParams.parentId = node.categoryId;
			} else {
				this.listParams.parentId = node.categoryId;
			}
			if (node.id != 0) {
				//this.AccountData.orgId = node.id;
			}
			this.$refs.selectReport.blur();
		},
		/**
		 * 获取列表
		 */
		async queryTableData() {
			this.loading = true;

			const { data: resData } = await this.$post("/v1/sku/plans/page", {
				...this.pages,
			});
			this.loading = false;
			if (resData.result != 200) return;
			this.tableData = resData.data.records;
			this.total = resData.data.total;
			this.tableData.forEach((item, index) => {
				if (item.checkboxStatus == 1) {
				}
			});
			this.$nextTick(() => {
				for (let i = 0; i < this.tableData.length; i++) {
					if (this.tableData[i].checkboxStatus == 1) {
						this.$refs.multipleTable.toggleRowSelection(this.tableData[i]);
					}
				}
			});

			this.getBatchList();
		},
		handleSelectionChange(val) {
			this.newdata = val;
			//清空选择
			// this.$nextTick(() => {
			//   for (var i = 0; i < this.$refs.multipleTable.length; i++) {
			//     this.$refs.multipleTable[i].clearSelection();
			//   }
			// });
		},
		/**
		 *  分页长度改变
		 */
		handleSizeChange(val) {
			this.pages.pageNo = 1;
			this.pages.pageSize = val;
			this.queryTableData();
		},

		/**
		 *  下一页
		 */
		handleCurrentChange(val) {
			this.pages.pageNo = val;
			this.queryTableData();
		},

		async handleClick(type, row = {}) {
			this.clickType = type;
			switch (type) {
				case "add":
					this.editMode = 'add';
					this.dialogVisible = true;
					this.flag = false;
					row.validStatus = 1;
					this.params = JSON.parse(JSON.stringify(row));
					this.$nextTick(() => {
						this.flag = true;
					});
					break;
				case "edit":
					if (this.newdata.length === 0) {
						this.$message.warning("请先选择要修改的数据");
						return;
					}
					this.editMode = 'edit';
					this.dialogVisible = true;
					break;
				case "del":
					this.delSub(this.newdata);
					break;
			}
		},
		// 新增或修改提交
		handleSub() {
			this.$refs.ruleForm.validate(async (valid) => {
				if (!valid) return;
				
				if (this.editMode === 'add') {
					// 新增逻辑
					console.log(this.subParams);
					const data = JSON.parse(JSON.stringify(this.subParams));
					data.trialPrice = Math.round(data.trialPrice * 100);
					data.firstSplitPaymentAmount = Math.round(data.firstSplitPaymentAmount * 100);
					data.price = Math.round(data.price * 100);
					data.totalPrice = Math.round(data.totalPrice * 100);
					const { data: resData } = await this.$post("/v1/sku/plans/batchCreat", {
						...data,
					});
					if (resData.result != 200) return;
					this.$message.success("新增成功!");
				} else {
					// 批量修改逻辑
					const ids = this.newdata.map(item => item.id).join(',');
					console.log(this.subParams);
					const data = JSON.parse(JSON.stringify(this.subParams));
					data.trialPrice = Math.round(data.trialPrice * 100);
					data.firstSplitPaymentAmount = Math.round(data.firstSplitPaymentAmount * 100);
					data.price = Math.round(data.price * 100);
					data.totalPrice = Math.round(data.totalPrice * 100);
					const { data: resData } = await this.$post("/v1/sku/plans/update", {
						...data,
						ids
					});
					if (resData.result != 200) return;
					this.$message.success("修改成功!");
				}
				
				this.dialogVisible = false;
				this.queryTableData();
			});
		},
		// 删除
		async delSub(row) {
			console.log("🚀 ~   ~ delSub ~ row:", row);
			this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const ids = row.map((item) => item.id);
				const { data: resData } = await this.$post(
					`/v1/sku/plans/delete?ids=${ids}`,
					{
						ids,
					}
				);
				if (resData.result != 200) return;
				this.queryTableData();
				this.$message.success("删除成功!");
			});
		},
		/**
		 * 修改发布状态
		 */
		async changeSwitchIssue(item) {
			const { data: resData } = await this.$post(
				`/v1/sku/plans/isEnableSubscribePlanSku?id=${item.id}&isOpen=${
					!!item.is_open == 1
				}`,
				{ id: item.id, isOpen: !!item.is_open == 1 }
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.$message.success(resData.message);
		},
		async changeSwitchTrial(item) {
			const { data: resData } = await this.$post(
				`/v1/sku/plans/updateSkuTrialStatus?id=${item.id}&isTrial=${item.is_trial}`,
				{ id: item.id, isTrial: item.is_trial }
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.$message.success(resData.message);
		},
		async changeSwitchRecommend(item) {
			const { data: resData } = await this.$post(
				`/v1/sku/plans/updateSkuRecommendStatus?id=${item.id}&isRecommend=${item.is_recommend}`,
				{ id: item.id, isRecommend: item.is_recommend }
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.$message.success(resData.message);
		},
	},
};
</script>

<style lang="scss" scoped>
:deep(.el-input-number) {
	width: 360px;
}
</style>